import DayPicker from 'react-day-picker'
import { withTheme } from 'styled-components'
import Nav from './DatepickerNav'
import YearAndMonth from './DatepickerYearAndMonth'
import Day from './DatepickerDay'
import localeUtils from './Intl'
import { observer, Observer } from 'mobx-react-lite'
// import Legend from './DatepickerLegend'
const Datepicker = withTheme(
  observer(props => {
    const { modifiers, selectedDay, onMonthChange, onDayMouseDown, modifiersMap, isLoading } = props
    const past = {
      before: new Date()
    }

    return (
      <>
        <DayPicker
          utc
          month={new Date(selectedDay)}
          selectedDays={[selectedDay]}
          onMonthChange={onMonthChange}
          onDayMouseDown={onDayMouseDown}
          modifiers={{ past, ...modifiers }}
          renderDay={(day, modifiers) => <Observer>{() => <Day day={day} modifiers={modifiers} modifiersMap={modifiersMap} />}</Observer>}
          localeUtils={localeUtils}
          locale={props.locale}
          captionElement={({ date }) => <YearAndMonth date={date} locale={props.locale} />}
          navbarElement={<Nav isLoading={isLoading} />}
        />
        {/* {props.responsive && <Legend />} */}
        <style>{props.projectStyles}</style>
      </>
    )
  })
)

export default Datepicker
